// extracted by mini-css-extract-plugin
export default {"video":"BackgroundVideoPlayer__video___H69dh"};